//10、拉手孔 
import makerjs from "makerjs";
// inputParam,model,this.myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function HandleHole(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,W=inputParam.W,H1=inputParam.H1,H2=inputParam.H2,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
 
   d = D*1*myZoom,
        w = W*1*myZoom,
        y0 = Y*1*myZoom,
        x0=X*1*myZoom,        
  xdis=(glassW * 1/2-w/2),
  ydis=(glassH * 1/2-w/2);
  if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              } 
        /*  
        d = D*1,
       xdis=(glassW * 1/2-W*1/2),
       ydis=(glassH * 1/2-W*1/2),
             w = W*1,
             y0 = Y*1,
             x0=X*1; 
             */    
        if(d!==0){
         var TxtD="∮"+D;
        }
        if(w!==0){          
        var TxtW=W;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(area==2){
   //画孔 B位置孔
        //标记拉手孔 B位置孔左
        var myHhHolesBLeft= new makerjs.models.Holes(d/2, [[xb, ye+w/2]]);
        //标记孔
        var myHhHolesMarkBLeft = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkBLeft.origin = [xb, ye+w/2];      
        var myHhHolesXMarkBLeft = new makerjs.models.Square(0);      
        myHhHolesXMarkBLeft.origin =[xb, ye+w/2];      
        var myHhHolesYMarkBLeft = new makerjs.models.Square(0);      
        myHhHolesYMarkBLeft.origin = [xb, ye+w/2];  
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkBLeft, new makerjs.paths.Line([0,0], [-markShiftThree, 0]));//从孔圆心出发X方向横向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkBLeft, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkBLeft, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/  
  /*****************************************************************************/ 
   //画孔 B位置孔
        //标记拉手孔 B位置孔右
        var myHhHolesBRight= new makerjs.models.Holes(d/2, [[xb, ye-w/2]]);
        var myHhHolesMarkBRight = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkBRight.origin = [xb, ye-w/2];      
        var myHhHolesXMarkBRight = new makerjs.models.Square(0);      
        myHhHolesXMarkBRight.origin =[xb, ye-w/2]; 
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkBRight, new makerjs.paths.Line([0,0], [0, w]));//从孔圆心出发X方向横向标线
  makerjs.model.addPath(myHhHolesMarkBRight, new makerjs.paths.Line([0,0], [-markShiftThree, 0]));//从孔圆心出发Y方向竖向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkBRight, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkBRight, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/   
  makerjs.model.addPath(myHhHolesXMarkBRight, new makerjs.paths.Line([0,0], [0, w]));//W短标线
  makerjs.model.addCaption(myHhHolesXMarkBRight, TxtW, [0-markShiftTwo,0], [0-markShiftTwo, w]);//W文字标注
  /*****************************************************************************/ 
  plate.models["TypeHoles_HandleHole_BLeft"+myHolesNum]=myHhHolesBLeft;
  cutPlate.models["TypeHoles_HandleHole_BLeft"+myHolesNum]=myHhHolesBLeft;
  markers.models["TypeHoles_HandleHole_BLeft"+myHolesNum]=myHhHolesBLeft;
  markers.models["TypeHoles_HandleHole_MarkBLeft"+myHolesNum]=myHhHolesMarkBLeft;
  markers.models["TypeHoles_HandleHole_XMarkBLeft"+myHolesNum]=myHhHolesXMarkBLeft;
  markers.models["TypeHoles_HandleHole_YMarkBLeft"+myHolesNum]=myHhHolesYMarkBLeft;
  /*****************************************************************************/
  plate.models["TypeHoles_HandleHole_BRight"+myHolesNum]=myHhHolesBRight;
  cutPlate.models["TypeHoles_HandleHole_BRight"+myHolesNum]=myHhHolesBRight;
  markers.models["TypeHoles_HandleHole_BRight"+myHolesNum]=myHhHolesBRight;
  markers.models["TypeHoles_HandleHole_MarkBRight"+myHolesNum]=myHhHolesMarkBRight;
  markers.models["TypeHoles_HandleHole_XMarkBRight"+myHolesNum]=myHhHolesXMarkBRight;
  /*****************************************************************************/ 
  
  }else if(area==4){
    //画孔 D位置孔
        //标记拉手孔 D位置孔上
        var myHhHolesDup= new makerjs.models.Holes(d/2, [[xd, yd+w/2]]);
        //标记孔
        var myHhHolesMarkDup = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkDup.origin = [xd, yd+w/2];      
        var myHhHolesXMarkDup = new makerjs.models.Square(0);      
        myHhHolesXMarkDup.origin =[xd, yd+w/2];      
        var myHhHolesYMarkDup = new makerjs.models.Square(0);      
        myHhHolesYMarkDup.origin = [xd, yd+w/2];  
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkDup, new makerjs.paths.Line([0,0], [0+d+markShiftFour, 0]));//从孔圆心出发X方向横向标线
  makerjs.model.addPath(myHhHolesMarkDup, new makerjs.paths.Line([0-x0,ydis], [0-x0, ydis+markShiftThree]));//Y轴加长标线
  makerjs.model.addPath(myHhHolesMarkDup, new makerjs.paths.Line([0,0], [0, ydis+markShiftTwo]));//从孔圆心出发Y方向竖向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkDup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkDup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/  
  makerjs.model.addPath(myHhHolesYMarkDup, new makerjs.paths.Line([0-x0,ydis+markShift], [0,ydis+markShift]));//X短标线
  makerjs.model.addCaption(myHhHolesYMarkDup, TxtX, [0-x0,ydis+markShiftFour], [0,ydis+markShiftFour]);//X文字标注
  /*****************************************************************************/ 
  /*****************************************************************************/ 
   //画孔 D位置孔
        //标记拉手孔 D位置孔下
        var myHhHolesDdn= new makerjs.models.Holes(d/2, [[xd, yd-w/2]]);
        var myHhHolesMarkDdn = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkDdn.origin = [xd, yd-w/2];      
        var myHhHolesXMarkDdn = new makerjs.models.Square(0);      
        myHhHolesXMarkDdn.origin =[xd, yd-w/2]; 
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkDdn, new makerjs.paths.Line([0,0], [d+markShiftFour, 0]));//从孔圆心出发X方向横向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkDdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkDdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/   
  makerjs.model.addPath(myHhHolesXMarkDdn, new makerjs.paths.Line([0+d+markShiftTwo,w], [0+d+markShiftTwo, 0]));//W短标线
  makerjs.model.addCaption(myHhHolesXMarkDdn, TxtW, [0+d+markShiftFour, 0], [0+d+markShiftFour,w]);//W文字标注
  /*****************************************************************************/  
  /*****************************************************************************/ /*****************************************************************************/ 
  plate.models["TypeHoles_HandleHole_Dup"+myHolesNum]=myHhHolesDup;
  cutPlate.models["TypeHoles_HandleHole_Dup"+myHolesNum]=myHhHolesDup;
  markers.models["TypeHoles_HandleHole_Dup"+myHolesNum]=myHhHolesDup;
  markers.models["TypeHoles_HandleHole_MarkDup"+myHolesNum]=myHhHolesMarkDup;
  markers.models["TypeHoles_HandleHole_XMarkDup"+myHolesNum]=myHhHolesXMarkDup;
  markers.models["TypeHoles_HandleHole_YMarkDup"+myHolesNum]=myHhHolesYMarkDup;
  /*****************************************************************************/
  plate.models["TypeHoles_HandleHole_Ddn"+myHolesNum]=myHhHolesDdn;
  cutPlate.models["TypeHoles_HandleHole_Ddn"+myHolesNum]=myHhHolesDdn;
  markers.models["TypeHoles_HandleHole_Ddn"+myHolesNum]=myHhHolesDdn;
  markers.models["TypeHoles_HandleHole_MarkDdn"+myHolesNum]=myHhHolesMarkDdn;
  markers.models["TypeHoles_HandleHole_XMarkDdn"+myHolesNum]=myHhHolesXMarkDdn;
  /*****************************************************************************/ 
 
  } else if(area==6){
    //画孔 F位置孔
        //标记拉手孔 F位置孔上
        var myHhHolesFup= new makerjs.models.Holes(d/2, [[xf, yf+w/2]]);
        //标记孔
        var myHhHolesMarkFup = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkFup.origin = [xf, yf+w/2];      
        var myHhHolesXMarkFup = new makerjs.models.Square(0);      
        myHhHolesXMarkFup.origin =[xf, yf+w/2];      
        var myHhHolesYMarkFup = new makerjs.models.Square(0);      
        myHhHolesYMarkFup.origin = [xf, yf+w/2];  
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkFup, new makerjs.paths.Line([0,0], [0+x0+markShiftFour, 0]));//从孔圆心出发X方向横向标线
  makerjs.model.addPath(myHhHolesMarkFup, new makerjs.paths.Line([0+x0,ydis], [0+x0, ydis+markShiftThree]));//Y轴加长标线
  makerjs.model.addPath(myHhHolesMarkFup, new makerjs.paths.Line([0,0], [0, ydis+markShiftTwo]));//从孔圆心出发Y方向竖向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkFup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkFup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/  
  makerjs.model.addPath(myHhHolesYMarkFup, new makerjs.paths.Line([0+x0,ydis+markShift], [0,ydis+markShift]));//X短标线
  makerjs.model.addCaption(myHhHolesYMarkFup, TxtX, [0,ydis+markShiftFour], [0+x0,ydis+markShiftFour]);//X文字标注
  /*****************************************************************************/ 
  /*****************************************************************************/ 
   //画孔 F位置孔
        //标记拉手孔 F位置孔下
        var myHhHolesFdn= new makerjs.models.Holes(d/2, [[xf, yf-w/2]]);
        var myHhHolesMarkFdn = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkFdn.origin = [xf, yf-w/2];      
        var myHhHolesXMarkFdn = new makerjs.models.Square(0);      
        myHhHolesXMarkFdn.origin =[xf, yf-w/2]; 
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkFdn, new makerjs.paths.Line([0,0], [x0+markShiftFour, 0]));//从孔圆心出发X方向横向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkFdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkFdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/   
  makerjs.model.addPath(myHhHolesXMarkFdn, new makerjs.paths.Line([0+x0+markShiftTwo,w], [0+x0+markShiftTwo, 0]));//W短标线
  makerjs.model.addCaption(myHhHolesXMarkFdn, TxtW, [0+x0+markShiftFour, 0], [0+x0+markShiftFour,w]);//W文字标注
  /*****************************************************************************/  
  /*****************************************************************************/ 
  /*****************************************************************************/ 
  plate.models["TypeHoles_HandleHole_Fup"+myHolesNum]=myHhHolesFup;
  cutPlate.models["TypeHoles_HandleHole_Fup"+myHolesNum]=myHhHolesFup;
  markers.models["TypeHoles_HandleHole_Fup"+myHolesNum]=myHhHolesFup;
  markers.models["TypeHoles_HandleHole_MarkFup"+myHolesNum]=myHhHolesMarkFup;
  markers.models["TypeHoles_HandleHole_XMarkFup"+myHolesNum]=myHhHolesXMarkFup;
  markers.models["TypeHoles_HandleHole_YMarkFup"+myHolesNum]=myHhHolesYMarkFup;
  /*****************************************************************************/
  plate.models["TypeHoles_HandleHole_Fdn"+myHolesNum]=myHhHolesFdn;
  cutPlate.models["TypeHoles_HandleHole_Fdn"+myHolesNum]=myHhHolesFdn;
  markers.models["TypeHoles_HandleHole_Fdn"+myHolesNum]=myHhHolesFdn;
  markers.models["TypeHoles_HandleHole_MarkFdn"+myHolesNum]=myHhHolesMarkFdn;
  markers.models["TypeHoles_HandleHole_XMarkFdn"+myHolesNum]=myHhHolesXMarkFdn;
  /*****************************************************************************/ 
  
  } else if(area==8){
  //画孔 H位置孔
        //标记拉手孔 H位置孔左
        var myHhHolesHLeft= new makerjs.models.Holes(d/2, [[xh, ye+w/2]]);
        //标记孔
        var myHhHolesMarkHLeft = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkHLeft.origin = [xh, ye+w/2];      
        var myHhHolesXMarkHLeft = new makerjs.models.Square(0);      
        myHhHolesXMarkHLeft.origin =[xh, ye+w/2];      
        var myHhHolesYMarkHLeft = new makerjs.models.Square(0);      
        myHhHolesYMarkHLeft.origin = [xh, ye+w/2];  
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkHLeft, new makerjs.paths.Line([0,0], [-markShiftThree, 0]));//从孔圆心出发X方向横向标线
  makerjs.model.addPath(myHhHolesMarkHLeft, new makerjs.paths.Line([0,0], [0, -w]));//X轴加长标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkHLeft, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkHLeft, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/ 
   //画孔 H位置孔
        //标记拉手孔 H位置孔右
        var myHhHolesHRight= new makerjs.models.Holes(d/2, [[xh, ye-w/2]]);
        var myHhHolesMarkHRight = new makerjs.models.Square(0); //孔的原点       
        myHhHolesMarkHRight.origin = [xh, ye-w/2];      
        var myHhHolesXMarkHRight = new makerjs.models.Square(0);      
        myHhHolesXMarkHRight.origin =[xh, ye-w/2]; 
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkHRight, new makerjs.paths.Line([0,0], [-markShiftThree, 0]));//从孔圆心出发Y方向竖向标线
  /*****************************************************************************/ 
  makerjs.model.addPath(myHhHolesMarkHRight, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
  makerjs.model.addCaption(myHhHolesMarkHRight, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
  /*****************************************************************************/   
  makerjs.model.addPath(myHhHolesXMarkHRight, new makerjs.paths.Line([0,0], [0, w]));//W短标线
  makerjs.model.addCaption(myHhHolesXMarkHRight, TxtW, [0-markShiftTwo,0], [0-markShiftTwo, w]);//W文字标注
  /*****************************************************************************/  
  /*****************************************************************************/
  plate.models["TypeHoles_HandleHole_HLeft"+myHolesNum]=myHhHolesHLeft;
  cutPlate.models["TypeHoles_HandleHole_HLeft"+myHolesNum]=myHhHolesHLeft;
  markers.models["TypeHoles_HandleHole_HLeft"+myHolesNum]=myHhHolesHLeft;
  markers.models["TypeHoles_HandleHole_MarkHLeft"+myHolesNum]=myHhHolesMarkHLeft;
  markers.models["TypeHoles_HandleHole_YMarkHLeft"+myHolesNum]=myHhHolesYMarkHLeft;
  /*****************************************************************************/
  plate.models["TypeHoles_HandleHole_HRight"+myHolesNum]=myHhHolesHRight;
  cutPlate.models["TypeHoles_HandleHole_HRight"+myHolesNum]=myHhHolesHRight;
  markers.models["TypeHoles_HandleHole_HRight"+myHolesNum]=myHhHolesHRight;
  markers.models["TypeHoles_HandleHole_MarkHRight"+myHolesNum]=myHhHolesMarkHRight;
  markers.models["TypeHoles_HandleHole_XMarkHRight"+myHolesNum]=myHhHolesXMarkHRight;
  /*****************************************************************************/ 
  } 

myHolesNum++;
return{plate,cutPlate,markers, myHolesNum}
};


export default HandleHole;